import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';
import { API_URL } from '../constants/urls';

export interface Proposition {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  focus_mode?: string;
  display_order: number;
  group_name?: string;
  group_id?: string;
}

export const propositionService = {
  async list(organizationId: string): Promise<Proposition[]> {
    const response = await axios.get(
      `${API_URL}/propositions?organization_id=${organizationId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  },

  async get(
    organizationId: string,
    propositionId: string,
  ): Promise<Proposition> {
    const response = await axios.get(
      `${API_URL}/propositions/${propositionId}?organization_id=${organizationId}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.data;
  },
};
